var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":"delete-account-modal","title":_vm.$t('Account.Delete'),"ok-title":_vm.$t('Validate'),"cancel-title":_vm.$t('Cancel'),"cancel-variant":"danger"},on:{"ok":_vm.handleOk}},[_c('div',{staticClass:"mb-4"},[_vm._v("\n    "+_vm._s(_vm.$t('Account.Delete.Confirm'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d46001a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/account/DeleteAccountModal.vue
// module id = Nsww
// module chunks = 0